import {DragDropContext, Droppable} from "react-beautiful-dnd";
import React from "react";

type Props = {
    id: string,
    onDragEnd: Function
};

export function DroppableComponent(props: Props) {
    const {id, onDragEnd} = props;
    const getListStyle = isDraggingOver => ({
        // background: isDraggingOver ? "#024a6c" : "#024a6c",
        padding: 4,
        // width: 250,
    });
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={'droppable_' + id}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        {...props}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {props.children}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}


// WEBPACK FOOTER //
// ./src/components/DragDrop/DroppableComponent.js